<template>
  <BaseModal
    v-if="visible"
    :title="computedTitle"
    @close-modal="emitClose"
  >
    <div class="error-modal">
      <p
        v-for="(message, index) in normalizedMessages"
        :key="`error-msg-${index}`"
        class="error-modal__message"
      >
        {{ message }}
      </p>
      <AppButton
        v-if="showCta"
        class="error-modal__cta"
        :label="ctaLabel || $t('Close')"
        :block="true"
        @click="emitClose"
      />
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/popup/modal/baseModal.vue';
import AppButton from '@/components/buttons/AppButton.vue';

export default {
  name: 'ErrorModal',
  components: {
    BaseModal,
    AppButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    messages: {
      type: Array,
      default: () => [],
    },
    fallbackMessage: {
      type: String,
      default: null,
    },
    ctaLabel: {
      type: String,
      default: null,
    },
    showCta: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    normalizedMessages() {
      if (Array.isArray(this.messages) && this.messages.length) {
        return this.messages
          .map((msg) => (msg ? String(msg).trim() : ''))
          .filter((msg) => msg.length > 0);
      }
      if (this.fallbackMessage) {
        return [this.fallbackMessage];
      }
      return [];
    },
    computedTitle() {
      if (this.title) {
        return this.title;
      }
      return this.$t('Something went wrong');
    },
  },
  methods: {
    emitClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.error-modal {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}

.error-modal__message {
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: #2d2244;
}

.error-modal__cta {
  align-self: stretch;
}
</style>
